import { ChangeEvent, useState } from "react";
import { uploadFile, UploadKind } from "../../ApiService/admin/Upload";
import { uploadUrl } from "../../utils/image";
import { useAdminLang } from "./i18n";

interface FileFieldProps {
  id: string;
  kind: UploadKind;
  value: string;
  onChange: (fileName: string) => void;
}

/** Uploads the chosen file right away and keeps only the stored file name as the value. */
export default function FileField({ id, kind, value, onChange }: FileFieldProps) {
  const { t } = useAdminLang();
  const [status, setStatus] = useState<"idle" | "uploading" | "error">("idle");
  const url = uploadUrl(value);

  const handleFile = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setStatus("uploading");
    try {
      onChange(await uploadFile(file, kind));
      setStatus("idle");
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        {url && kind === "image" && (
          <span className="avatar avatar-lg">
            <img src={url} alt="" />
          </span>
        )}
        {url && kind === "resume" && (
          <a href={url} target="_blank" rel="noreferrer" className="btn btn-sm btn-light">
            <i className="ri-file-pdf-2-line me-1"></i>{t("مشاهده فایل")}
          </a>
        )}
        <input
          id={id}
          type="file"
          className="form-control w-auto flex-fill"
          accept={kind === "image" ? ".jpg,.jpeg,.png,.webp,.gif" : ".pdf"}
          onChange={handleFile}
          disabled={status === "uploading"}
        />
        {value && (
          <button type="button" className="btn btn-sm btn-danger-light" onClick={() => onChange("")}>
            {t("حذف")}
          </button>
        )}
      </div>
      <div className="form-text">
        {status === "uploading"
          ? t("در حال آپلود...")
          : status === "error"
            ? <span className="text-danger">{t("آپلود انجام نشد.")}</span>
            : kind === "image"
              ? t("JPG، PNG، WEBP یا GIF تا ۲ مگابایت")
              : t("PDF تا ۵ مگابایت")}
      </div>
    </div>
  );
}
